var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container modal-term p-0"},[_c('div',{staticClass:"overflow-scroll-gradient"},[_c('div',{staticClass:"overflow-scroll-gradient__scroller",domProps:{"innerHTML":_vm._s(_vm.termsContent)}})])]),_c('modal-master',{attrs:{"controller":_vm.modalController}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }